import $ from "jquery";

$(document).ready(function() {
    $('.jsTabButton').on('click', function() {

        const    that = $(this),
            tabContainer = that.closest('.jsTabs'),
            tabContentItem = tabContainer.find('.jsTabItem'),
            ndx = that.closest('.tabs__button-col').index(),
            reqItem = tabContentItem.eq(ndx);

        if (!that.hasClass('is-active')) {

            tabContainer.find('.jsTabButton.is-active').removeClass('is-active');
            tabContainer.find('.tabs__button-col.is-active').removeClass('is-active');

            that.addClass('is-active');
            that.closest('.tabs__button-col').addClass('is-active');

            tabContentItem.removeClass('is-active');
            reqItem.addClass('is-active');
        }
    });

});


